import request from '@/utils/request'

/**
 * 获取车辆状态
 * @param {*} data
 */
function getCarStatus(data) {
  return request({
    url: '/carstatus/list',
    method: 'post',
    data
  })
}

/**
 * 导出
 * @param {*} data
 */
function exportCar(data) {
  return request({
    url: '/terminalfaulthit/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}

/**
 * 获取获取WebSocket连接端口
 * @param {*} params
 */
function getWebSocket() {
  return request({
    url: '/mapcontrol/getwsport',
    method: 'get'
  })
}

/**
 * 获取车辆基础数据
 * @param {*} params
 */
function getcarinfo(id) {
  return request({
    url: `/carstatus/car/info/${id}`,
    method: 'get'
  })
}

/**
 * 获取车辆基础数据下半部分name
 * @param {*} params
 */
function getdbcvar(md5) {
  return request({
    url: `/carstatus/dbc/var/${md5}`,
    method: 'get'
  })
}


/**
 * 获取单车实时数据
 * @param {*} params
 */
function getrealtimedata(id) {
  return request({
    url: `/carstatus/real-time/${id}`,
    method: 'get'
  })
}



export {
  getCarStatus,
  exportCar,
  getWebSocket,
  getcarinfo,
  getdbcvar,
  getrealtimedata
}
